import React, { FC } from 'react';
import { Box, Container } from '@mui/material';
import { cssGlobals } from '../../app';

export const Footer: FC = () => <Container
  maxWidth={false}
  sx={{
    fontSize: 14,
    maxWidth: cssGlobals.panelsContainerMaxWidth,
  }}>
    <Box sx={{
      mx: 'auto',
      py: 3,
      borderTop: 1,
      borderColor: 'text.disabled',
      display: 'flex',
      justifyContent: 'space-between',
    }}>
      <div>MondecaLabs - Copyright 2022</div>
      <div>Report an issue? Please <a target="_blank" rel="noreferrer" href="mailto:dev@mondeca.com">Contact us</a></div>
    </Box>
</Container>;
